import type { AvailableLanguages, TitleChapters } from "~/src/api";

export function getChapterSequenceForLang(
  type: "chapters" | "novelChapters",
  aggregate: TitleChapters,
  lang: AvailableLanguages,
) {
  // get null vol if any ahead of time
  const nullVol = aggregate.attributes.list.find((vol) => vol.volume === null);

  const langChapters = aggregate.attributes.list
    // remove null vol
    .filter((vol) => vol.volume !== null)
    .flatMap((vol) => vol[type].map((ch) => ({ ...ch, volume: vol.volume })));
  const chapters = langChapters.filter((ch) => ch.translatedLanguage === lang);

  // add all null vol chapters to the end except oneshots
  const nullVolChapters =
    nullVol?.[type]
      .map((ch) => ({ ...ch, volume: null }))
      .filter((ch) => ch.translatedLanguage === lang)
      // remove oneshots
      .filter((ch) => ch.chapter !== null) ?? [];
  chapters.push(...nullVolChapters);

  // add the oneshot(s) in at the beginning if any exist
  const oneshotsInLang =
    nullVol?.[type]
      .map((ch) => ({ ...ch, volume: null }))
      .filter((ch) => ch.translatedLanguage === lang && !ch.chapter) ?? [];
  if (oneshotsInLang.length) chapters.unshift(...oneshotsInLang);

  return chapters;
}

export function getAvailableLanguageVariants(
  type: "chapters" | "novelChapters",
  aggregate: TitleChapters,
  chapterId: string,
) {
  const currentVol = aggregate.attributes.list.find((vol) =>
    vol.chapters.some((ch) => ch.id === chapterId),
  );

  if (!currentVol) return [];
  const currChapter = currentVol[type].find((ch) => ch.id === chapterId);
  if (!currChapter) return [];

  const availChapters = currentVol[type].filter(
    (ch) => ch.chapter === currChapter.chapter,
  );

  const availLangs = availChapters.map((ch) => ch.translatedLanguage);

  // not everything is unique, dont show variants
  if (availLangs.length !== new Set(availLangs).size) return [];

  return availChapters;
}
